import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFeature, IProjectConfig, IProjectConfigAddFeature, IProjectConfigDepartmentId, IProjectConfigLabel, IProjectConfigUpdateFeature } from "../../../interface/interfaces";
import { PROJECT_CONFIG_FEATURE_LIST } from "../../../constants/constants";
import { remove } from "lodash";
import { stat } from "fs";

interface IInitialState{
    projectFeatureList: IProjectConfig[];
    errorMessage: string | null; 
}

// const storedProjectFeatureList = localStorage.getItem(PROJECT_CONFIG_FEATURE_LIST);

// let initialProjectFeatureList: IProjectConfig[] = [];
const initialProjectFeatureList: IProjectConfig[] = [];

// try {
//     initialProjectFeatureList = storedProjectFeatureList ? JSON.parse(storedProjectFeatureList) : [];
// } catch (error) {
//     // eslint-disable-next-line no-console
//     console.error('Error parsing all project config items from local storage:', error);
//     initialProjectFeatureList = [];
// }

const initialState: IInitialState = {
    projectFeatureList: initialProjectFeatureList,
    errorMessage: null 
}

const projectFeatureListFastUpdateSlice = createSlice({
    name: 'projectFeatureListFastUpdate',
    initialState,
    reducers: {
        saveProjectFeatureList: (state: IInitialState, action: PayloadAction<IProjectConfig[]>) => {
            state.projectFeatureList = action.payload;
            // localStorage.setItem(PROJECT_CONFIG_FEATURE_LIST, JSON.stringify(action.payload));
        },
        clearProjectFeatureList: (state: IInitialState) => {
            state.projectFeatureList = [];
            // localStorage.removeItem(PROJECT_CONFIG_FEATURE_LIST);
        },

        removeProjectItem: (state: IInitialState, action: PayloadAction<number>) => {
            state.projectFeatureList = state.projectFeatureList.filter(item => item.DepartmentId !== action.payload);
            // localStorage.setItem(PROJECT_CONFIG_FEATURE_LIST, JSON.stringify(state.projectFeatureList));
        },
        addProjectItem: (state: IInitialState, action: PayloadAction<IProjectConfig>) => {
            state.projectFeatureList = [...state.projectFeatureList, action.payload];
            // localStorage.setItem(PROJECT_CONFIG_FEATURE_LIST, JSON.stringify(state.projectFeatureList));
        },

        modifyProjectItem: (state: IInitialState, action: PayloadAction<{ DepartmentId: number, Label: string }>) => {
            const index = state.projectFeatureList.findIndex(item => item.DepartmentId === action.payload.DepartmentId);
            if (index !== -1) {
                state.projectFeatureList[index].Label = action.payload.Label;
                // localStorage.setItem(PROJECT_CONFIG_FEATURE_LIST, JSON.stringify(state.projectFeatureList));
            }
        },
        addFeature: (state: IInitialState, action: PayloadAction<{DepartmentId: number, Feature: IFeature}>) => {
            const departmentIndex = state.projectFeatureList.findIndex(item => item.DepartmentId === action.payload.DepartmentId);
            if (departmentIndex !== -1) {
                const featureExists = state.projectFeatureList[departmentIndex].Features.some(feature => feature.Tool === action.payload.Feature.Tool);
                if (featureExists) {
                    state.errorMessage = `Feature ${action.payload.Feature.Tool} already exists in this department.`;
                } else {
                    state.projectFeatureList[departmentIndex].Features.unshift(action.payload.Feature);
                    state.errorMessage = null;
                }
            }
            
            // localStorage.setItem(PROJECT_CONFIG_FEATURE_LIST, JSON.stringify(state.projectFeatureList));
        },

        removeFeature: (state: IInitialState, action: PayloadAction<{ DepartmentId: number, Tool: string }>) => {
            const departmentIndex = state.projectFeatureList.findIndex(item => item.DepartmentId === action.payload.DepartmentId);
                if (departmentIndex !== -1) {
                    state.projectFeatureList[departmentIndex].Features = state.projectFeatureList[departmentIndex].Features.filter(
                        feature => feature.Tool !== action.payload.Tool
                );
            }
        },
        updateFeature: (state: IInitialState, action: PayloadAction<IProjectConfigUpdateFeature>) => {
            const departmentIndex = state.projectFeatureList.findIndex(item => item.DepartmentId === action.payload.DepartmentId);
            if (departmentIndex !== -1) {
                const featureIndex = state.projectFeatureList[departmentIndex].Features.findIndex(
                    feature => feature.FeatureName === action.payload.FeatureName
                );
                if (featureIndex !== -1) {
                    state.projectFeatureList[departmentIndex].Features[featureIndex] = action.payload.UpdatedFeature;
                    // localStorage.setItem(PROJECT_CONFIG_FEATURE_LIST, JSON.stringify(state.projectFeatureList));
                }
            }
        }
    }
});

export default projectFeatureListFastUpdateSlice.reducer;
export const { saveProjectFeatureList, clearProjectFeatureList, removeProjectItem, addProjectItem, addFeature, removeFeature, updateFeature, modifyProjectItem } = projectFeatureListFastUpdateSlice.actions;